export default __webpack_public_path__ + "static/media/vire22.0864814a.jpg";